export default __webpack_public_path__ + "static/media/NeueMachina-Light.a62c505b.woff";